// extracted by mini-css-extract-plugin
export var cardHeader = "_e3-0";
export var reorderHandle = "_e3-3";
export var titleArea = "_e3-1";
export var titleAreaWithHandle = "_e3-2";